/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule4_ActionInputs */

const tr_landing_pricerules_mock_rule4_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule4_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taban fiyatın üstünde otomatik yeni teklif`)
};

const en_landing_pricerules_mock_rule4_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule4_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic new offer above floor price`)
};

const de_landing_pricerules_mock_rule4_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule4_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch neues Angebot über Mindestpreis`)
};

const ru_landing_pricerules_mock_rule4_action = /** @type {(inputs: Landing_Pricerules_Mock_Rule4_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоставка выше минимальной цены`)
};

/**
* | output |
* | --- |
* | "Automatic new offer above floor price" |
*
* @param {Landing_Pricerules_Mock_Rule4_ActionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule4_action = /** @type {((inputs?: Landing_Pricerules_Mock_Rule4_ActionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule4_ActionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule4_action(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule4_action(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule4_action(inputs)
	return tr_landing_pricerules_mock_rule4_action(inputs)
});